<template>
  <div class="modal-card" style="width: 400px; min-height: 300px">
    <header class="modal-card-head">
      <p class="modal-card-title">Add product</p>
    </header>
    <section class="modal-card-body">
      <b-field label="Enter product name">
        <b-taginput
          v-model="selectedProducts"
          :disabled="isLoading"
          :data="allProducts"
          autocomplete
          rounded
          type="is-primary"
          field="name"
          placeholder="Add a product">
        </b-taginput>
      </b-field>
    </section>
    <footer class="modal-card-foot">
      <button class="button is-primary full-width-button" :class="{'is-loading': isLoading}" @click="manageProducts">Save</button>
    </footer>
  </div>
</template>

<script>
import ProductsService from "./service";

export default {
  name: "addProduct",

  props: ["city", "products"],

  created() {
    this.fetchAllProducts();
  },

  data() {
    return {
      isLoading: true,
      selectedProducts: [],
      allProducts: []
    };
  },

  methods: {
    fetchAllProducts() {
      ProductsService.allProducts().then(data => {
        if (this.products.length) {
          this.allProducts = data.filter(item => {
            return (
              this.products.filter(product => {
                return product.product.docId === item.docId;
              }).length === 0
            );
          });
        } else {
          this.allProducts = data;
        }

        this.isLoading = false;
      });
    },

    manageProducts() {
      this.isLoading = true;

      ProductsService.addProducts(this.city, this.selectedProducts).then(() => {
        this.isLoading = false;
        this.$toast.open("Product added successfully");
        this.$emit("close");
      });
    },

    getFilteredTags(text) {
      this.allProducts = this.allProducts.filter(option => {
        return (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(text.toLowerCase()) >= 0
        );
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/hotel/Products/AddProduct.vue